export const getBoxPreviewInstance = () =>
  typeof Box !== typeof undefined && "Preview" in (Box || {})
    ? new Box.Preview()
    : null;
